/**
 * Onboarding Types
 * Defines the structure for therapist onboarding setup steps and tracking
 */

export enum OnboardingStepId {
  CONNECT_BANK = 'connect_bank',
  SUBSCRIPTION_PLAN = 'subscription_plan',
  ADD_SERVICES = 'add_services',
  SET_AVAILABILITY = 'set_availability',
  COMPLETE_PROFILE = 'complete_profile',
}

export interface OnboardingStep {
  id: OnboardingStepId
  title: string
  description: string
  icon: string // MUI icon name or custom icon
  actionText: string
  actionPath: string // Route to navigate to
  completed: boolean
  required: boolean
  order: number
  color?: string // Optional accent color for the card
}

export interface OnboardingProgress {
  userId: string
  steps: OnboardingStep[]
  completedCount: number
  totalCount: number
  completionPercentage: number
  lastUpdated: string
  isOnboardingComplete: boolean
}

export interface OnboardingCardProps {
  step: OnboardingStep
  onAction: (stepId: OnboardingStepId) => void
  onMarkComplete?: (stepId: OnboardingStepId) => void
  animationDelay?: number
}

export interface OnboardingSetupCardsProps {
  showCompleted?: boolean
  maxCards?: number
  onComplete?: () => void
}

export interface OnboardingStatusResponse {
  isConnectBank: boolean
  isSubscriptionTaken: boolean
  isServiceCreated: boolean
  isSlotAdded: boolean
}
